import {AfterViewInit, Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {IconComponent} from "../../../../elements/icon/icon.component";
import {Icons} from "../../../../../model/icon";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-contacts-page',
  imports: [
    IconComponent,
    NgClass
  ],
  templateUrl: './contacts-page.component.html',
  styleUrl: './contacts-page.component.scss'
})
export class ContactsPageComponent implements AfterViewInit {
  @ViewChild('title') titleElement!: ElementRef;
  isHighlighted: boolean = false;

  ngAfterViewInit() {
    this.checkTitlePosition();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkTitlePosition();
  }

  checkTitlePosition() {
    const rect = this.titleElement.nativeElement.getBoundingClientRect();
    const screenHeight = window.innerHeight;


    this.isHighlighted = rect.top < screenHeight / 3;
  }
  protected readonly Icons = Icons;
}
